export const PACKAGE_VERSION = Object.keys({
  __packageVersion__: "xxxx",
})[0] as string;
